<template>
  <v-dialog v-model="dialog" width="560" persistent>
    <template v-slot:activator="{ on }">
      <v-btn color="orange white--text" depressed v-on="on" class="mr-3 my-3">
        <v-icon left>forum</v-icon>
        Chatflow
      </v-btn>
    </template>
    <v-card class="px-4 py-4">
      <v-card-title class="subtitle-1 pb-2">Chatflow Alert (Telegram)</v-card-title>
      <v-card-text>
        <p class="text-caption text--secondary mb-3">
          Aktif kanal ve rehber alıcıları seçin. İş veya agent uyarıları Telegram üzerinden iletilir.
        </p>
        <v-autocomplete
          dense
          outlined
          clearable
          v-model="draft.channelId"
          :items="channels"
          item-text="label"
          item-value="id"
          label="Aktif kanal"
          :loading="loading"
          no-data-text="Aktif kanal yok"
          @change="onChannelChange"
        />
        <v-autocomplete
          dense
          outlined
          multiple
          chips
          small-chips
          deletable-chips
          class="mt-3"
          v-model="draft.contactIds"
          :items="filteredContacts"
          item-text="label"
          item-value="id"
          label="Rehber alıcıları"
          :disabled="!draft.channelId"
          :loading="loading"
          no-data-text="Bu kanal için uygun kişi yok"
        />
        <v-textarea
          dense
          outlined
          rows="2"
          auto-grow
          class="mt-3"
          v-model="draft.message"
          label="Ek not (isteğe bağlı)"
          :hint="
            messageHint ||
            'Agent: boş bırakın. Task: boşsa iş sonucu metni gider. Workflow: boş bırakın — süreç adı ve durum otomatik yazılır.'
          "
          persistent-hint
          :disabled="!draft.channelId"
        />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" depressed :disabled="!canSave" @click="save">Save</v-btn>
        <v-btn depressed @click="cancel">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ChatflowApi from "../../chatflow/api";

export default {
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    messageHint: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      channelRows: [],
      contactRows: [],
      draft: {
        channelId: null,
        contactIds: [],
        message: "",
      },
    };
  },
  computed: {
    channels() {
      return (this.channelRows || [])
        .filter((c) => c.active !== false)
        .map((c) => ({
          id: c.id,
          label: `${c.name || "Kanal"} (${c.type}${c.credentials?.botUsername ? ` @${c.credentials.botUsername}` : ""})`,
        }));
    },
    filteredContacts() {
      if (!this.draft.channelId) return [];
      return (this.contactRows || [])
        .filter((c) => this.contactReachable(c, this.draft.channelId))
        .map((c) => ({
          id: c.id,
          label: c.displayName || c.primaryEmail || c.telegramChatId || c.id,
        }));
    },
    canSave() {
      return !!this.draft.channelId && this.draft.contactIds.length > 0;
    },
  },
  watch: {
    dialog(open) {
      if (open) {
        this.syncDraftFromValue();
        this.loadData();
      }
    },
  },
  methods: {
    contactReachable(contact, channelId) {
      if (contact.telegramChatId) return true;
      return (contact.identities || []).some((id) => id.channelId === channelId);
    },
    syncDraftFromValue() {
      const v = this.value || {};
      this.draft = {
        channelId: v.channelId || null,
        contactIds: Array.isArray(v.contactIds) ? [...v.contactIds] : [],
        message: v.message || "",
      };
    },
    onChannelChange() {
      const allowed = new Set(this.filteredContacts.map((c) => c.id));
      this.draft.contactIds = this.draft.contactIds.filter((id) => allowed.has(id));
    },
    async loadData() {
      this.loading = true;
      try {
        const [channels, contacts] = await Promise.all([
          ChatflowApi.getChannels(),
          ChatflowApi.getContacts({ limit: 100 }),
        ]);
        this.channelRows = channels || [];
        this.contactRows = contacts || [];
      } catch (e) {
        this.channelRows = [];
        this.contactRows = [];
      } finally {
        this.loading = false;
      }
    },
    save() {
      if (!this.canSave) return;
      this.$emit("input", {
        channelId: this.draft.channelId,
        contactIds: [...this.draft.contactIds],
        message: (this.draft.message || "").trim(),
      });
      this.dialog = false;
    },
    cancel() {
      this.$emit("input", null);
      this.dialog = false;
    },
  },
};
</script>
